// latest: wjk 2017-11-7 5:05 PM
/* global $ u  */
import {Post, URLs} from 'common'
import uMessage from 'components/message'
import uLoading from 'components/loadingPanel'
function init (refer, obj) {
  var _refer = refer
  let vm, data
  debugger
  if (refer.params.data) {
    data = refer.params.data
    vm = {
      generate: async function () {
        // debugger
        _refer.cancel()
        vm.startExec()
        let result = await Post(URLs.qlftpl_saveEdition.url, data)
        if (result.status == 1) {
          vm.endExec(false, 'success', result.msg)
          setTimeout(function () {
            window.global.back()
          }, 1000)
        } else {
          vm.endExec(true, 'fail', result.msg)
        }
      },
      noGenerate: async function () {
        // debugger
        _refer.cancel()
        vm.startExec()
        let result = await Post(URLs.qlftpl_saveData.url, data)
        if (result.status == 1) {
          vm.endExec(false, 'success', result.msg)
          setTimeout(function () {
            window.global.back()
          }, 1500)
        } else {
          vm.endExec(true, 'fail', result.msg)
        }
      },
      // loading效果
      loadingStartTime: null,
      startExec: function () {
        this.loadingStartTime = new Date().getTime()
        uLoading.show('开始处理...')
        setTimeout(function () {
          uLoading.progress('系统处理中...')
        }, 1000)
      },
      endExec: function (hidden, type, message) {
        if (hidden) {
          let loadingEndTime = new Date().getTime()
          if (loadingEndTime - this.loadingStartTime > 1500) {
            uLoading.hide()
            uMessage(type, message)
          } else {
            setTimeout(function () {
              uLoading.hide()
              uMessage(type, message)
            }, 1000)
          }
        } else {
          uLoading.progress(message)
          uMessage(type, message)
        }
      },
    }
  }
  let app = u.createApp()
  app.init(vm, $('#new_cert_sorting')[0])
  refer.registerSubmitFunc(() => {
    return vm
  })
}
let template = require('./index.html')
export default {
  init,
  template
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/saveEditionDateRefer/index.js